<template>
  <v-container id="regular-tables" fluid tag="section">
    <base-material-card icon="mdi-clipboard-text" title="Negociación" class="px-5 py-3">
      <v-col>
        <v-row class="pt-8">
          <v-col>
            <v-select v-model="selectedProspector" label="Prospector" outlined clearable :items="prospectadores"
              @change="filtroTabla()" />
          </v-col>
          <v-col>
            <v-select v-model="selectAsesores" outlined label="Asesor" clearable :items="asesores"
              @change="filtroTabla()" />
          </v-col>
          <v-col>
            <v-select v-model="selectEtapa" outlined label="Etapa" clearable :items="computedEtapas"
              @change="filtroTabla()" />
          </v-col>
          <v-col>
            <v-select v-model="selectFechaFacturacion" clearable outlined label="Fecha facturación"
              :items="['Todos', '2021-08', '2021-09', '2021-10', '2021-11', '2021-12',
                '2022-01', '2022-02', '2022-03', '2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09', '2022-10', '2022-11', '2022-12',
                '2023-01', '2023-02', '2023-03', '2023-04', '2023-05', '2023-06', '2023-07', '2023-08', '2023-09', '2023-10', '2023-11', '2023-12',
                '2024-01', '2024-02', '2024-03', '2024-04', '2024-05', '2024-06', '2024-07', '2024-08', '2024-09', '2024-10', '2024-11', '2024-12',
                '2025-01', '2025-02', '2025-03', '2025-04', '2025-05', '2025-06', '2025-07', '2025-08', '2025-09', '2025-10', '2025-11', '2025-12',
                '2026-01', '2026-02', '2026-03', '2026-04', '2026-05', '2026-06', '2026-07', '2026-08', '2026-09', '2026-10', '2026-11', '2026-12',
                '2027-01', '2027-02', '2027-03', '2027-04', '2027-05', '2027-06', '2027-07', '2027-08', '2027-09', '2027-10', '2027-11', '2027-12',
                '2028-01', '2028-02', '2028-03', '2028-04', '2028-05', '2028-06', '2028-07', '2028-08', '2028-09', '2028-10', '2028-11', '2028-12',
                '2029-01', '2029-02', '2029-03', '2029-04', '2029-05', '2029-06', '2029-07', '2029-08', '2029-09', '2029-10', '2029-11', '2029-12',
                '2030-01', '2030-02', '2030-03', '2030-04', '2030-05', '2030-06', '2030-07', '2030-08', '2030-09', '2030-10', '2030-11', '2030-12']" @change="filtroTabla()" />
          </v-col>
          <v-col>
            <v-text-field v-model="search" outlined label="Buscar en proyectos..." />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <download-excel v-if="$store.getters.hasPermission('Proyectos', 'Descargar')" :data='downloadTable'
              worksheet='Data'>
              <v-btn v-if="$store.getters.hasPermission('Proyectos', 'Descargar')" color="primary">Descargar data
                <v-icon> mdi-download </v-icon>
              </v-btn>
            </download-excel>
          </v-col>
        </v-row>
      </v-col>
      <v-data-table :headers="headers" :items="proyectos" :search="search" item-key="name" class="elevation-1"
        :loading="isLoadingTable">
        <template v-slot:[`item.montoPuertas`]="{ item }">
          S/. {{ new Intl.NumberFormat().format(parseInt(item.montoPuertas)) }}
        </template>

        <template v-slot:[`item.montoCerraduras`]="{ item }">
          S/. {{ new Intl.NumberFormat().format(parseInt(item.montoCerraduras)) }}
        </template>

        <template v-slot:[`item.montoCortafuego`]="{ item }">
          S/. {{ new Intl.NumberFormat().format(parseInt(item.montoCortafuego)) }}
        </template>

        <template v-slot:[`item.accions`]="{ item }">

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="inspectProject(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>Ver detalles</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="$store.getters.hasPermission('Proyectos', 'Editar')" small class="mr-2" v-bind="attrs"
                v-on="on" @click="changeProspectorAsesor(item)">
                mdi-account-convert
              </v-icon>
            </template>
            <span>Cambiar Prospector/Vendedor</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="$store.getters.hasPermission('Proyectos', 'Negociación')" small class="mr-2" v-bind="attrs"
                v-on="on" @click="openNegociarProyecto(item)">
                mdi-clipboard-text-outline
              </v-icon>
            </template>
            <span>Negociar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="comentariosProyecto(item)">
                mdi-comment-quote
              </v-icon>
            </template>
            <span>Comentarios</span>
          </v-tooltip>

          <v-tooltip v-if="$store.getters.hasPermission('Proyectos', 'Eliminar')" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click="ConfirmarEliminarProyecto(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>

    <v-dialog v-model="dialogNegociarProyecto" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ proyecto.nombre }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <template>
              <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit()">
                <v-menu ref="menuFechaCotizacion" v-model="menuFechaCotizacion" :close-on-content-click="false"
                  :return-value.sync="dateFechaCotizacion" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="proyecto.dateFechaCotizacion" label="Fecha de cotización"
                      prepend-icon="mdi-calendar" readonly outlined required
                      :rules="[v => !!v || 'Fecha de cotización es obligatorio']" v-bind="attrs" v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="proyecto.dateFechaCotizacion" type="month" no-title scrollable>
                    <v-spacer />
                    <v-btn text color="primary" @click="menuFechaCotizacion = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menuFechaCotizacion.save(proyecto.dateFechaCotizacion)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-menu ref="menuFechaFacturacion" v-model="menuFechaFacturacion" :close-on-content-click="false"
                  :return-value.sync="dateFechaFacturacion" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="proyecto.dateFechaFacturacion" label="Fecha de facturación"
                      prepend-icon="mdi-calendar" readonly outlined required
                      :rules="[v => !!v || 'Fecha de facturación es obligatorio']" v-bind="attrs" v-on="on">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="proyecto.dateFechaFacturacion" type="month" no-title scrollable>
                    <v-spacer />
                    <v-btn text color="primary" @click="menuFechaFacturacion = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.menuFechaFacturacion.save(proyecto.dateFechaFacturacion)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-select v-model="proyecto.tipoVivienda" :items="$store.state.tipos"
                  :rules="[v => !!v || 'Tipo de obra es obligatorio']" label="Seleccione el tipo de obra"
                  data-vv-name="select" outlined required />
                <v-select v-model="proyecto.etapa" :items="$store.state.etapas" label="Seleccione la etapa de obra"
                  data-vv-name="select" outlined required :rules="[v => !!v || 'Etapa de obra es obligatorio']" />
                <v-combobox v-model="proyecto.ipv" :items="$store.state.ipvs" :search-input.sync="searchIpv"
                  hide-selected label="¿Qué IPV realiza el servicio?" persistent-hint outlined
                  :rules="[v => !!v || 'IPV es obligatorio']" />
                <v-select v-model="subsidiariaDIMFER" :items="empresaDIMFER"
                  label="Subsidiaria / Filial del Grupo DIMFER" data-vv-name="empresaDIMFER" outlined
                  :rules="[v => !!v || 'Subsidiaria / Filial es obligatorio']" />
                <v-text-field v-model="proyecto.cantidadPuertas" label="Cantidad de puertas" outlined
                  :rules="[v => !!v || 'Cantidad de puertas es obligatorio', v => v > 0 || 'Cantidad de puerta debe ser mayor a 0']" />
                <v-text-field v-model="proyecto.montoPuertas" label="Monto puertas y marcos*" prefix="S/." outlined
                  :rules="[v => !!v || 'Monto de puertas es obligatorio', v => v > 0 || 'Monto de puerta debe ser mayor a 0']" />
                <v-text-field v-model="proyecto.montoCerraduras" label="Monto cerraduras y bisagras" prefix="S/."
                  outlined
                  :rules="[v => !!v || 'Monto cerraduras y bisagras es obligatorio', v => v > 0 || 'Monto cerraduras y bisagras debe ser mayor a 0']" />
                <v-text-field v-model="proyecto.cantidadCortafuego" label="Cantidad Puertas Cortafuego" outlined
                  :rules="[v => !!v || 'Cantidad Puertas Corta es obligatorio']" />
                <v-text-field v-model="proyecto.cantidadDuctos" label="Cantidad Ductos" outlined
                  :rules="[v => !!v || 'Cantidad Ductos es obligatorio']" />
                <v-text-field v-model="proyecto.montoCortafuego" label="Monto puertas Corta Fuego y Ductos" prefix="S/."
                  outlined :rules="[v => !!v || 'Monto Cerraduras y Ductos es obligatorio']" />
                <v-select v-model="proyecto.reunion" :items="['SÍ', 'NO']" label="¿Hubo reunión?" data-vv-name="select"
                  outlined :rules="[v => !!v || 'Hubo reunión es obligatorio']" />
                <v-select v-model="proyecto.tipoSistema" :items="['TRADICIONAL', 'PRE COLGADO', 'HÍBRIDO']"
                  label="Tipo de sistema" data-vv-name="select" outlined
                  :rules="[v => !!v || 'Tipo de sistema es obligatorio']" />
                <v-select v-model="proyecto.tipoCliente" :items="['NUEVO', 'ANTIGUO']" label="Tipo de cliente"
                  data-vv-name="select" outlined :rules="[v => !!v || 'Tipo de cliente es obligatorio']" />
                <v-select v-model="proyecto.medioContacto" :items="$store.state.medioContacto" label="Medio de contacto"
                  data-vv-name="select" outlined :rules="[v => !!v || 'Medio de contacto es obligatorio']" />
                <v-slider v-model="proyecto.posibilidadCierre" label="Posibilidad de cierre" step="10"
                  color="orange darken-3" thumb-label ticks
                  :rules="[v => v > 0 || 'Posibilidad de cierre debe ser mayor a 0']" />
                <v-select v-model="proyecto.estadoNegociacion" :items="$store.state.estadoNegociacion.slice(3)"
                  label="Seleccione el estado de negociación" data-vv-name="select" outlined
                  :rules="[v => !!v || 'Estado de negociación es obligatorio']" />
                <v-combobox v-if="proyecto.estadoNegociacion === 'PERDIDO'" v-model="proyecto.quienGano"
                  :items="computedProveedores" :search-input.sync="searchQuienGano" hide-selected label="Quién ganó?"
                  persistent-hint outlined />
                <v-text-field v-if="proyecto.estadoNegociacion === 'PERDIDO'" v-model="proyecto.razonPerdido"
                  label="Porqué se perdió?" outlined />
                <v-alert type="info"> Agregar un contacto del área de compras, de preferencia decisor para el
                  seguimiento</v-alert>
                <v-select v-model="selectContactoNegociacion" :items="contactosProyecto"
                  @change="changeContactoNegociacion()" hide-selected label="Agrega contacto" persistent-hint
                  outlined />
                <v-col v-if="isNewContacto">
                  <v-row>
                    <v-text-field v-model="newContact.contactName" label="Nombre de contacto" outlined />
                    <v-text-field v-model="newContact.contactTelephone" outlined label="Teléfono Personal" max="9" />
                    <v-text-field v-model="newContact.contactTelephone2" outlined label="Teléfono Corporativo"
                      max="9" />
                    <v-text-field v-model="newContact.addressContact" outlined label="Dirección de oficina" />
                    <v-text-field v-model="newContact.emailContact" outlined label="Email Personal" />
                    <v-text-field v-model="newContact.emailContact2" outlined label="Email Corporativo" />
                    <v-text-field v-model="newContact.positionContact" outlined label="Cargo"
                      :rules="[v => !!v || 'Item is required']" />
                  </v-row>
                </v-col>

                <v-textarea v-model="negotiationComment" label="Comentario*" outlined auto-grow counter="500" required
                  :rules="[v => !!v || 'El comentario es obligatorio']" />
                <v-row>
                  <v-spacer />
                  <div class="mx-3" />
                  <v-btn color="danger" @click="dialogNegociarProyecto = false">
                    Cerrar
                  </v-btn>
                  <v-btn class="mr-4" color="primary" type="submit" :loading="isLoadingSubmit">
                    Crear
                  </v-btn>
                </v-row>
              </v-form>
            </template>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogComment" width="100%">
          <v-card>
            <v-card-title class="text-h5">
              Comentarios del proyecto
            </v-card-title>

            <v-card-text>
              <v-text-field v-model="manualComment" label="Agrege un comentario" outlined />
              <v-btn @click="addManualComment()">
                Agregar comentario
              </v-btn>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <template>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Usuario
                        </th>
                        <th class="text-left">
                          Comentario
                        </th>
                        <th class="text-left">
                          Comentado el:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="comment in commentsProyecto" :key="comment.i">
                        <td>{{ comment.usuario }}</td>
                        <td style="white-space: pre-line;">{{ comment.comment }}</td>
                        <td>{{ formatDate(comment.createdAt) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialogChangeProspectorAseor" width="100%">
          <v-card>
            <v-card-title class="text-h5">
              Cambiar Prospector/Asesor
            </v-card-title>

            <v-card-text>
              <v-select v-model="changeProspectorAsesorSelect.prospector" :items="prospectores"
                label="Seleccione nuevo prospector del proyecto">
              </v-select>
              <v-select v-model="changeProspectorAsesorSelect.asesor" :items="asesoresChange"
                label="Seleccione nuevo asesor del proyecto">
              </v-select>
              <v-btn @click="saveChangeProspectorAsesor()" :loading="isLoadingChangeProspectorAsesorSelect">
                Guardar cambios
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <v-snackbar v-model="alertIncompleto">
      Falta llenar campos
    </v-snackbar>

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogConfirmEliminar" persistent max-width="500">
          <v-card>
            <v-card-title>
              ¿Esta seguro de eliminar este proyecto?
            </v-card-title>
            <v-card-text>Una vez que elimina el proyecto ya no podra recuperarlo</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="green darken-1" text @click="dialogConfirmEliminar = false">
                Cancelar
              </v-btn>
              <v-btn color="green darken-1" text :loading="isLoadingEliminar" @click="eliminarProyecto()">
                Aceptar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-dialog v-model="isProjectDetailsDialogVisible" max-width="600px">
      <v-card>
        <v-card-title>Detalles del Proyecto</v-card-title>
        <v-card-text v-if="selectedProject">

          <div v-for="(item, index) in filteredProjectFields" :key="index">
            <strong>{{ item.label }}:</strong>
            <span v-if="isUrl(item.value)">
              <a :href="item.value" target="_blank" rel="noopener">Ver archivo</a>
            </span>
            <span v-else>
              {{ item.value }}
            </span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="isProjectDetailsDialogVisible = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import firebase from 'firebase'
const db = firebase.firestore()

export default {
  data() {
    return {
      chargedProjects: false,
      negotiationComment: '',
      cotizacion: '',
      copiaCorreo: '',
      selectAsesores: 'Todos',
      selectEtapa: 'Todos',
      search: '',
      selectFechaFacturacion: 'Todos',
      selectedProspector:'Todos',
      manualComment: '',
      searchIpv: '',
      searchQuienGano: '',
      subsidiariaDIMFER: '',
      selectedProject: null,
      selectProyecto: null,
      selectContactoNegociacion: null,
      dateFechaCotizacion: null,
      dateFechaFacturacion: null,
      isProjectDetailsDialogVisible: false,
      isLoadingEliminar: false,
      dialogConfirmEliminar: false,
      alertIncompleto: false,
      isLoadingChangeProspectorAsesorSelect: false,
      dialogComment: false,
      dialogChangeProspectorAseor: false,
      valid: true,
      isNewContacto: false,
      menuFechaCotizacion: false,
      menuFechaFacturacion: false,
      isLoadingTable: false,
      isLoadingSubmit: false,
      dialogNegociarProyecto: false,
      changeProspectorAsesorSelect: {
        prospector: '',
        asesor: '',
      },
      newContact: {
        contactName: '',
        contactTelephone: '',
        contactTelephone2: '',
        addressContact: '',
        emailContact: '',
        emailContact2: '',
        positionContact: '',
      },
      fieldLabels: {
        codigo: 'Código',
        nombre: 'Nombre del Proyecto',
        categoria: 'Categoría',
        tipo: 'Tipo',
        tipoCliente: 'Tipo de Cliente',
        tipoSistema: 'Tipo de Sistema',
        tipoVivienda: 'Tipo de Vivienda',
        etapa: 'Etapa',
        direccion: 'Dirección',
        region: 'Región',
        provincia: 'Provincia',
        foto: "Foto",
        asesor: 'Asesor',
        prospector: 'Prospector',
        quienProspecto: 'Quién Prospectó',
        constructora: 'Constructora',
        inmobiliaria: 'Inmobiliaria',
        cotizacion: 'Cotización',
        copiaCorreo: 'Copia Correo',
        propectadoAt: 'Fecha de Prospección',
        dateFechaCotizacion: 'Fecha de Cotización',
        dateFechaFacturacion: 'Fecha de Facturación',
        fechaEntrega: 'Fecha de Entrega',
        ipv: 'IPV',
        numeroDepartamentos: 'Número de Departamentos',
        numeroPisos: 'Número de Pisos',
        proveedorActual: 'Proveedor Actual',
        subsidiariaDIMFER: 'Empresa DIMFER',
      },
      proveedores: [],
      nuevosProveedores: [],
      asesoresChange: [],
      prospectores: [],
      commentsProyecto: [],
      proyecto: [],
      namesProyectos: [],
      contactosProyecto: [],
      proyectos: [],
      prospectadores: ['Todos'],
      asesores: ['Todos'],
      etapas: ['Todos'],
      empresaDIMFER: ['Forestal Santa Rosa', 'Casavid'],
    }
  },
  computed: {
    filteredProjectFields() {
      if (!this.selectedProject) return []
      return Object.keys(this.fieldLabels)
        .filter(key => this.selectedProject[key] && this.fieldLabels[key])
        .map(key => ({
          label: this.fieldLabels[key],
          value: this.selectedProject[key]
        }));
    },
    computedProveedores: function () {
      var results = this.$store.state.proveedores
      return results
    },
    computedEtapas: function () {
      this.$store.state.etapas.forEach(etapa => {
        this.etapas.push(etapa)
      })
      return this.etapas
    },
    headers() {
      return [
        {
          text: 'Nombre de proyecto',
          align: 'start',
          sortable: false,
          value: 'nombre',
        },
        { text: 'Constructora', value: 'constructora' },
        { text: 'Provincia/Distrito', value: 'provincia' },
        { text: 'Prospector', value: 'prospector' },
        { text: 'F. Facturación', value: 'dateFechaFacturacion' },
        { text: 'Estado Negociacion', value: 'estadoNegociacion' },
        { text: 'Monto Puertas', value: 'montoPuertas' },
        { text: 'Monto Cerraduras', value: 'montoCerraduras' },
        { text: 'Monto Cortafuego', value: 'montoCortafuego' },
        { text: 'P. Cierre', value: 'posibilidadCierre' },
        { text: 'Asesor', value: 'asesor' },
        { text: 'Etapa', value: 'etapa' },
        { text: 'Can. Puertas', value: 'cantidadPuertas' },
        { text: 'Prospectado el', value: 'propectadoAt' },
        { text: 'Prospectado por', value: 'quienProspecto' },
        { text: 'Accions', value: 'accions', sortable: false },
      ]
    },
    downloadTable: function () {
      var downloadData = []
      this.proyectos.forEach(proyecto => {
        const data = {
          MODULO: 'Negociacion',
          LATITUD: proyecto.latitud,
          LONGITUD: proyecto.longitud,
          REGION: proyecto.region,
          PROVINCIA: proyecto.provincia,
          CÓDIGO: proyecto.codigo,
          CATEGORÍA: proyecto.categoria,
          'TIPO DE OBRA': proyecto.tipo,
          PROPIETARIO: proyecto.inmobiliaria,
          CONSTRUYE: proyecto.constructora,
          DIRECCIÓN: proyecto.direccion,
          PROYECTO: proyecto.nombre,
          PROSPECTOR: proyecto.prospector,
          ASESOR: proyecto.asesor,
          'ESTADO NEGOCIACION': proyecto.estadoNegociacion,
          'TIPO CLIENTE': proyecto.tipoCliente,
          'PROVEEDOR ACTUAL': proyecto.proveedorActual,
          'PROVEEDOR ACTUAL AGRUPADO': proyecto.proveedorActualAgrupado,
          ETAPA: proyecto.etapa,
          PISOS: proyecto.numeroPisos,
          DEPARTAMENTOS: proyecto.numeroDepartamentos,
          'RANGO VIVIENDA': proyecto.rangoVivienda,
          AÑO: proyecto.anio,
          ENTREGA: '\'' + proyecto.fechaEntrega,
          FOTO: proyecto.foto,
          COTIZACION: proyecto.dateFechaCotizacion,
          FACTURACION: proyecto.dateFechaFacturacion,
          IPV: proyecto.ipv,
          subsidiariaDIMFER: proyecto.subsidiariaDIMFER,
          'CANTIDAD PUERTAS': proyecto.cantidadPuertas,
          'PROSPECTADO El': proyecto.propectadoAt,
          'PROSPECTADO POR': proyecto.quienProspecto,
          'MONTO PUERTAS': proyecto.montoPuertas,
          'MONTO CERRADURA Y BIZAGRA': proyecto.montoCerraduras,
          'CANTIDAD CORTAFUEGO': proyecto.cantidadCortafuego,
          'CANTIDAD DUCTOS': proyecto.cantidadDuctos,
          'MONTO CORTAFUEGO Y DUCTOS': proyecto.montoCortafuego,
          'HUBO REUNION': proyecto.reunion,
          'TIPO SITEMA': proyecto.tipoSistema,
          'POSIBILIDAD CIERRE': proyecto.posibilidadCierre,
          'QUIEN GANÓ': proyecto.quienGano,
          'MEDIO CONTACTO': proyecto.medioContacto,
          'POR QUE SE PERDIÓ': proyecto.razonPerdido,
          'FECHA PROSPECCION A NEGOCIACION': proyecto.propectadoAt,
          'QUIEN PROSPECTO': proyecto.quienProspecto,

        }
        downloadData.push(data)
      })
      return downloadData
    },

  },
  watch: {
    '$store.state.userAuth'(user) {
      if (user) {
        /* console.log('[watch] userAuth disponible, cargando proyectos...') */
        this.getProyectos()
      }
    }
  },
  mounted() {
    this.getAsesores()
    if (this.$store.state.userAuth) {
      this.executeChargedProjects()
    } else {
      const unwatch = this.$watch('$store.state.userAuth', (user) => {
        if (user) {
          this.executeChargedProjects()
          unwatch()
        }
      })
    }
    this.getProspectores()
    this.getProveedores()
  },
  methods: {
    executeChargedProjects() {
      if (!this.chargedProjects) {
        this.getProyectos()
        this.chargedProjects = true
      }
    },
    filtroTabla() {
      this.isLoadingTable = true
      this.namesProyectos = []
      this.proyectos = []
      var projectQuery = firebase.firestore().collection('proyectos')
      projectQuery = projectQuery.where('fase', '==', 3)

      if (this.selectedProspector !== 'Todos') {
        projectQuery = projectQuery.where('prospector', '==', this.selectedProspector)
      }

      if (this.selectAsesores !== 'Todos') {
        projectQuery = projectQuery.where('asesor', '==', this.selectAsesores)
      }
      if (this.selectEtapa !== 'Todos') {
        projectQuery = projectQuery.where('etapa', '==', this.selectEtapa)
      }
      if (this.selectFechaFacturacion !== 'Todos') {
        projectQuery = projectQuery.where('dateFechaFacturacion', '==', this.selectFechaFacturacion)
      }
      projectQuery.get().then((projectsSnapshot) => {
        projectsSnapshot.forEach((doc) => {
          var visitas = null
          if (doc.data().visitas !== undefined) {
            visitas = doc.data().visitas.length
          } else {
            visitas = '0'
          }
          const data = {
            id: doc.id,
            asesor: doc.data().asesor,
            codigo: doc.data().codigo,
            latitud: doc.data().latitud,
            longitud: doc.data().longitud,
            nombre: doc.data().nombre,
            direccion: doc.data().direccion,
            region: doc.data().region,
            provincia: doc.data().provincia,
            tipo: doc.data().tipo,
            categoria: doc.data().categoria,
            estadoNegociacion: doc.data().estadoNegociacion,
            estado: doc.data().estado,
            numeroPisos: doc.data().numeroPisos,
            numeroDepartamentos: doc.data().numeroDepartamentos,
            etapa: doc.data().etapa,
            fechaEntrega: doc.data().entrega,
            inmobiliaria: doc.data().inmobiliaria,
            constructora: doc.data().constructora,
            proveedorActual: doc.data().proveedorActual,
            prospector: doc.data().prospector,
            visitas: visitas,
            foto: doc.data().foto,
            planos: doc.data().planos,
            metrados: doc.data().metrados,
            fechaCreacion: this.formatoFecha(doc.data().fechaCreacion),
            fecha_edicion: '',
            anio: '',
            usuario: doc.data().usuario,
            dateFechaCotizacion: doc.data().dateFechaCotizacion,
            dateFechaFacturacion: doc.data().dateFechaFacturacion,
            tipoVivienda: doc.data().tipoVivienda,
            ipv: doc.data().ipv,
            subsidiariaDIMFER: doc.data().subsidiariaDIMFER,
            cantidadPuertas: doc.data().cantidadPuertas,
            propectadoAt: doc.data().propectadoAt,
            quienProspecto: doc.data().quienProspecto,
            montoPuertas: doc.data().montoPuertas,
            montoCerraduras: doc.data().montoCerraduras,
            montoCortafuego: doc.data().montoCortafuego,
            reunion: doc.data().reunion,
            tipoSistema: doc.data().tipoSistema,
            tipoCliente: doc.data().tipoCliente,
            medioContacto: doc.data().medioContacto,
            posibilidadCierre: doc.data().posibilidadCierre,
            quienGano: doc.data().quienGano,
            razonPerdido: doc.data().razonPerdido,
            comments: doc.data().comments,
            cotizacion: doc.data().cotizacion,
            copiaCorreo: doc.data().copiaCorreo,
          }
          this.proyectos.push(data)
        })
        this.isLoadingTable = false
      })
    },
    getAsesores() {
      const filteredAdvisors = []
      firebase.firestore().collection('perfiles').get().then((asesoresSnapshot) => {
        asesoresSnapshot.forEach((asesor) => {
          const data = asesor.data()
          if (
            data &&
            data.Proyectos &&
            data.Proyectos.Negociación === true
          ) {
            filteredAdvisors.push(asesor.id)
          }
        })
        /* console.log("perfiles filtrados: ",filteredAdvisors) */

        firebase.firestore().collection('users').get().then((usersSnapshot) => {
          usersSnapshot.forEach((user) => {
            const userData = user.data()
            if (filteredAdvisors.includes(userData.perfil)) {
              this.asesores.push(userData.email)
              this.asesoresChange.push(userData.email)
              /* console.log("usuarios filtrados:" ,userData.email) */
            }
          })
        })
      })
    },
    getProveedores() {
      firebase.firestore().collection('proyectos').get().then(results => {
        results.forEach(result => {
          this.nuevosProveedores.push(result.data().quienGano)
        })
      })
    },
    getProspectores() {
      const filteredProfiles = []
      firebase.firestore().collection('perfiles').get().then((prospectoresSnapshot) => {
        prospectoresSnapshot.forEach((prospector) => {
          const data = prospector.data()
          if (
            data &&
            data.Proyectos &&
            data.Proyectos.Prospección === true
          ) {
            filteredProfiles.push(prospector.id)
          }
        })
        /* console.log("Perfiles filtrados:", filteredProfiles) */
        firebase.firestore().collection('users').get().then((usersSnapshot) => {
          usersSnapshot.forEach((user) => {
            const userData = user.data()
            if (filteredProfiles.includes(userData.perfil)) {
              this.prospectores.push(userData.email)
              this.prospectadores.push(userData.email)
              /* console.log("Usuario Permitido: ", userData.email) */
            }
          })
        })
      })
    },
    comentariosProyecto(data) {
      this.selectProyecto = data.codigo;
      this.dialogComment = true;
      this.commentsProyecto = [];

      firebase.firestore().collection('proyectos').doc(data.codigo).get()
        .then(doc => {
          if (doc.exists) {
            const proyecto = doc.data();
            this.commentsProyecto = proyecto.comments || [];
          } else {
            console.warn('Proyecto no encontrado');
          }
        })
        .catch(error => {
          console.error('Error al cargar comentarios del proyecto:', error);
        });
    },
    addManualComment(codigo, comentario) {
      return new Promise((resolve, reject) => {
        const texto = (comentario || '').trim();
        const user = JSON.parse(localStorage.userAuth);
        const newComment = {
          usuario: user.email,
          createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
          comment: texto,
        };
        firebase.firestore().collection('proyectos').doc(codigo).update({
          comments: firebase.firestore.FieldValue.arrayUnion(newComment),
        }).then(() => {
          firebase.firestore().collection('proyectos').doc(codigo).get().then(doc => {
            if (doc.exists) {
              const data = doc.data();
              this.commentsProyecto = data.comments || [];
              resolve();
            } else {
              reject(new Error('Documento no existe'));
            }
          }).catch(reject);
        }).catch(reject);
      });
    },
    formatDate(timestamp) {
      return timestamp && timestamp.toDate
        ? timestamp.toDate().toLocaleString()
        : 'Sin fecha'
    },
    changeContactoNegociacion() {
      if (this.selectContactoNegociacion === 'Agregar nuevo contacto') {
        this.isNewContacto = true
      } else {
        this.isNewContacto = false
      }
    },
    changeProspectorAsesor(item) {
      this.dialogChangeProspectorAseor = true
      this.changeProspectorAsesorSelect.prospector = item.prospector
      this.changeProspectorAsesorSelect.asesor = item.asesor
      this.changeProspectorAsesorSelect.codigo = item.codigo
    },
    saveChangeProspectorAsesor() {
      this.isLoadingChangeProspectorAsesorSelect = true
      firebase.firestore().collection('proyectos').doc(this.changeProspectorAsesorSelect.codigo).set({
        prospector: this.changeProspectorAsesorSelect.prospector,
        asesor: this.changeProspectorAsesorSelect.asesor,
      }, { merge: true }).then(() => {
        this.isLoadingChangeProspectorAsesorSelect = false
        this.dialogChangeProspectorAseor = false
        this.getProyectos()
      })
    },
    sliderError(val) {
      if (val === 0) {
        return 'Debe indicar una posibilidad de cierre'
      }
    },
    getProyectos() {
      this.isLoadingTable = true
      this.namesProyectos = []
      this.proyectos = []

      const puedeVerTodo = this.$store.getters.hasPermission('Proyectos', 'VerTodo')
      const userEmail = this.$store.state.userAuth.email || ''

      let projectQuery = db.collection('proyectos').where('fase', '==', 3)

      projectQuery.get().then((projectsSnapshot) => {
        projectsSnapshot.forEach((doc) => {
          const data = doc.data()

          if (puedeVerTodo || data.prospector === userEmail) {
            const visitas = data.visitas !== undefined ? data.visitas.length : '0'

            this.proyectos.push({
              ...data,
              visitas,
              fechaCreacion: this.formatoFecha(data.fechaCreacion),
              fecha_edicion: data.fecha_edicion,
              id: doc.id,
            })
          }
        })

        this.isLoadingTable = false
      })
    },
    openNegociarProyecto(item) {
      this.contactosProyecto = []
      this.contactosProyecto.push('Agregar nuevo contacto')
      if (item.inmobiliaria) {
        firebase.firestore().collection('contacts').doc(item.inmobiliaria).get().then(result => {
          result.data().contactos.forEach(contacto => {
            this.contactosProyecto.push(contacto.emailContact)
          })
        })
      }
      this.proyecto = item
      this.dialogNegociarProyecto = true
      this.negotiationComment = ''
    },
    ConfirmarEliminarProyecto(item) {
      this.selectProyecto = item
      this.dialogConfirmEliminar = true
    },
    eliminarProyecto() {
      this.isLoadingEliminar = true
      console.log("Se eliminará el siguiente proyecto de manera irreversible :"
        , this.selectProyecto.nombre, this.selectProyecto)
      firebase.firestore().collection('proyectos').doc(this.selectProyecto.codigo).delete().then(() => {
        this.dialogConfirmEliminar = false
        this.isLoadingEliminar = false
        this.getProyectos()
      })
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.alertIncompleto = true
        return
      }
      if (this.selectContactoNegociacion === 'Agregar nuevo contacto') {
        firebase.firestore().collection('contacts').doc(this.proyecto.constructora).set({
          type: 1,
          contactos: firebase.firestore.FieldValue.arrayUnion({
            contactName: this.newContact.contactName,
            contactTelephone: this.newContact.contactTelephone,
            contactTelephone2: this.newContact.contactTelephone2,
            addressContact: this.newContact.addressContact,
            emailContact: this.newContact.emailContact,
            emailContact2: this.newContact.emailContact2,
            positionContact: this.newContact.positionContact,
            associated: this.proyecto.constructora,
          }),
        }, { merge: true })
        this.selectContactoNegociacion = this.newContact.emailContact
      }
      this.isLoadingSubmit = true
      this.proyecto.subsidiariaDIMFER = this.subsidiariaDIMFER
      firebase.firestore().collection('proyectos').doc(this.proyecto.id).get().then(doc => {
        if (!doc.exists) {
          this.isLoadingSubmit = false
          return
        }
        const original = doc.data()
        const changes = []
        const fieldsToCompare = [
          'dateFechaCotizacion', 'dateFechaFacturacion', 'tipoVivienda', 'etapa',
          'ipv', 'subsidiariaDIMFER', 'cantidadPuertas', 'montoPuertas', 'montoCerraduras',
          'montoCortafuego', 'cantidadCortafuego', 'cantidadDuctos', 'reunion',
          'tipoSistema', 'tipoCliente', 'medioContacto', 'posibilidadCierre',
          'estadoNegociacion',
        ]
        fieldsToCompare.forEach(field => {
          const newValue = this.proyecto[field]
          const oldValue = original[field]
          if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
            changes.push(`${field}: ${newValue}`)
          }
        })
        const user = JSON.parse(localStorage.userAuth)
        const automaticNegotiationComment = {
          usuario: user.email,
          createdAt: firebase.firestore.Timestamp.fromDate(new Date()),
          comment: changes.length > 0 ? `⚙️ Se modificó:\n ${changes.join('\n')}` : 'No se realizaron cambios.'
        }
        const updatedData = {
          dateFechaCotizacion: this.proyecto.dateFechaCotizacion,
          dateFechaFacturacion: this.proyecto.dateFechaFacturacion,
          tipoVivienda: this.proyecto.tipoVivienda,
          etapa: this.proyecto.etapa,
          ipv: this.proyecto.ipv,
          subsidiariaDIMFER: this.proyecto.subsidiariaDIMFER,
          cantidadPuertas: this.proyecto.cantidadPuertas,
          montoPuertas: this.proyecto.montoPuertas,
          montoCerraduras: this.proyecto.montoCerraduras,
          montoCortafuego: this.proyecto.montoCortafuego,
          cantidadCortafuego: this.proyecto.cantidadCortafuego,
          cantidadDuctos: this.proyecto.cantidadDuctos,
          reunion: this.proyecto.reunion,
          tipoSistema: this.proyecto.tipoSistema,
          tipoCliente: this.proyecto.tipoCliente,
          medioContacto: this.proyecto.medioContacto,
          posibilidadCierre: this.proyecto.posibilidadCierre,
          estadoNegociacion: this.proyecto.estadoNegociacion,
          quienGano: this.proyecto.quienGano,
          razonPerdido: this.proyecto.razonPerdido,
          contactoNegociacion: this.selectContactoNegociacion,
          comments: firebase.firestore.FieldValue.arrayUnion(automaticNegotiationComment),
        }
        this.logAutomaticComment(this.proyecto.codigo, automaticNegotiationComment.comment, this.proyecto)
          .catch(err => {
            console.error('Error guardando log automático en globalLog:', err)
          })
        firebase.firestore().collection('proyectos').doc(this.proyecto.id).set(updatedData, { merge: true }).then(() => {
          if (this.negotiationComment && this.negotiationComment.trim() !== '') {
            this.addManualComment(this.proyecto.id, this.negotiationComment).then(() => {
              this.comentario = ''
              this.comentariosProyecto({ codigo: this.proyecto.id })
            })
          }

          this.isLoadingSubmit = false
          this.dialogNegociarProyecto = false
          this.getProyectos()
        }).catch(() => {
          this.isLoadingSubmit = false
        })
      })
    },
    logAutomaticComment(codigo, comentario, proyectoData) {
      const user = JSON.parse(localStorage.userAuth);
      const logData = {
        codigoProyecto: codigo,
        nombreProyecto: proyectoData.nombre || '',
        comentario: comentario,
        usuario: user.email,
        perfil: user.perfil,
        fecha: firebase.firestore.Timestamp.fromDate(new Date()),
        estadoNegociacion: proyectoData.estadoNegociacion || '',
        constructora: proyectoData.constructora || '',
        inmobiliaria: proyectoData.inmobiliaria || '',
        tipo: proyectoData.tipo || '',
        region: proyectoData.region || '',
        provincia: proyectoData.provincia || '',
        fase: proyectoData.fase || 1,
        asesor: proyectoData.asesor || user.email,
        prospector: proyectoData.prospector || user.email
      };

      return firebase.firestore().collection('globalLog').add(logData);
    },
    formatoFecha() {
      const fecha = new Date()
      const formato = 'dd/mm/yy'
      const map = {
        dd: fecha.getDate(),
        mm: fecha.getMonth() + 1,
        yy: fecha.getFullYear().toString().slice(-2),
        yyyy: fecha.getFullYear(),
      }
      const date = formato.replace(/dd|mm|yy|yyy/gi, matched => map[matched])
      return date + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds()
    },
    openLink(url) {
      if (url && url.startsWith("http")) {
        window.open(url, '_blank');
      } else {
        this.$toast.info('Archivo no disponible.');
      }
    },
    inspectProject(item) {
      const excludedFields = ['id', 'estadoNegociacion', 'montoCortafuego',
        'comentarios', 'visitas', 'razonPerdido', 'estado', 'fechaCreacion',
        'fase', 'quienGano', 'reunion', 'quienGano', 'montoPuertas', 'fechaEdicion',
        'montoCerraduras', 'planos', 'comments', 'longitud', 'latitud', 'cantidadDuctos', "metrados"
      ];
      this.selectedProject = Object.fromEntries(
        Object.entries(item).filter(([key]) => !excludedFields.includes(key))
      );
      this.isProjectDetailsDialogVisible = true;
    },
    isUrl(value) {
      return typeof value === 'string' && value.startsWith('http');
    }
  },
}
</script>
